import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass(['visitor', 'visitor-view', 'blacklist', 'grid--vertical'])
}
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "binding-items" }
const _hoisted_4 = { class: "blacklist__image" }
const _hoisted_5 = { class: "preview" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form_item, {
              prop: "salutation",
              label: _ctx.trans('label.salutation')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.model.salutation,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.salutation) = $event)),
                  "automatic-dropdown": false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.mr'),
                      value: "Mr"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.ms'),
                      value: "Ms"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.mrs'),
                      value: "Mrs"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.miss'),
                      value: "Miss"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.prof'),
                      value: "Prof"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      label: _ctx.trans('label.dr'),
                      value: "Dr"
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "lastName",
              label: _ctx.trans('label.last-name'),
              rules: {
						required: true,
						message: _ctx.trans('message.field_require', _ctx.trans('label.last-name'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.lastName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.lastName) = $event)),
                  maxlength: 50,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_el_form_item, {
              prop: "firstName",
              label: _ctx.trans('label.first-name')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.firstName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.firstName) = $event)),
                  maxlength: 50,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "phone",
              label: _ctx.trans('label.phone')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.phone,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.phone) = $event)),
                  maxlength: 20,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "email",
              label: _ctx.trans('label.email'),
              rules: {
						type: 'email',
						message: _ctx.trans('message.field_not-email', _ctx.trans('label.email'))
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.email,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.email) = $event)),
                  maxlength: 100,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_el_form_item, {
              prop: "voidBy",
              label: _ctx.trans('label.blacklisted-by'),
              rules: {
						required: true,
						message: _ctx.trans(
							'message.field_require',
							_ctx.trans('label.blacklisted-by')
						)
					}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.model.voidBy,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.voidBy) = $event)),
                  placeholder: _ctx.trans('label.nothing-selected'),
                  filterable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.staffs, (staff) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: staff.userId,
                        label: `Staff: ${staff.lastName} ${staff.firstName}`,
                        value: staff.userId
                      }, null, 8, ["label", "value"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenants, (tenant) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: tenant.tenantId,
                        label: `${_ctx.trans('label.tenant')}: ${tenant.tenantName}`,
                        value: 10000000 + tenant.tenantId
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_el_form_item, {
              prop: "isHenderson",
              label: "Henderson"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: _ctx.model.isHenderson,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.isHenderson) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              prop: "remarks",
              label: _ctx.trans('label.remarks')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.model.remarks,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.remarks) = $event)),
                  type: "textarea",
                  autosize: {
							minRows: 3,
							maxRows: 10
						},
                  maxlength: 500,
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_card, { class: "binding-item" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      class: "preview-img",
                      src: _ctx.model.image || _ctx.visitorImage
                    }, null, 8, _hoisted_6)
                  ]),
                  (_ctx.mode !== 'view')
                    ? (_openBlock(), _createElementBlock("small", _hoisted_7, _toDisplayString(_ctx.trans("message.upload_limit_remarks")), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("input", {
                      class: "select-image",
                      ref: "selectImage",
                      type: "file",
                      accept: "image/jpeg,image/png,image/gif",
                      onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.uploadImage && _ctx.uploadImage(...args)))
                    }, null, 544),
                    (_ctx.mode !== 'view')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "primary",
                          disabled: false,
                          onClick: _cache[9] || (_cache[9] = () => _ctx.selectImage.click())
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.trans("label.upload")), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_skeleton, {
        key: 1,
        rows: 10
      }))
}